import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DictionaryModule,  CommonUIModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from '@sdbn/tmc-common';
import { TapableTerminalCardModule } from '@sdbn/tmc-common';
import { DocumentScannerPreviewDialog } from './component/document-scanner-preview-dialog';
import { TransportRegistrationDocumentScanComponent } from './component/transport-registration-document-scan.component';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    TransportRegistrationDocumentScanComponent,
    DocumentScannerPreviewDialog
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    TapableTerminalCardModule,
    CenteredScrollableContentModule,
    CommonTranslationModule,
    CommonUIModule,
    MatDialogModule
]
})
export class TransportRegistrationDocumentScanModule { }
